import * as util from '../apiUtils';
import * as common from '../apiCommon';
import * as DocType from '../../constants/constant_doc_types';
import { get } from 'lodash';

function parseDocData(data = {}) {
  const docData = {
    doc_type: DocType.PRINT_TEMPLATE,
    active: util.toBoolean(data.active),
    name: util.toStringText(data.name),
    template_type: util.toStringText(data.template_type),
    apply_to: util.toStringText(data.apply_to),
    output_type: util.toStringText(data.output_type),
    description: util.toStringText(data.description),
    template_text: util.toStringText(data.template_text),
    template_text_subject: util.toStringText(data.template_text_subject),
    parent_id: util.toStringText(data.parent_id),
  };

  if (get(data, 'layout')) {
    docData.layout = {
      id: get(data, 'layout.id'),
      cell_columns: util.toNumber(get(data, 'layout.cell_columns')),
      cell_height: util.toNumber(get(data, 'layout.cell_height')),
      cell_horizontal_gap: util.toNumber(get(data, 'layout.cell_horizontal_gap')),
      cell_rows: util.toNumber(get(data, 'layout.cell_rows')),
      cell_vertical_gap: util.toNumber(get(data, 'layout.cell_vertical_gap')),
      cell_width: util.toNumber(get(data, 'layout.cell_width')),
      height: util.toNumber(get(data, 'layout.height')),
      width: util.toNumber(get(data, 'layout.width')),
      orientation: util.toStringText(get(data, 'layout.orientation')),
      page_size: util.toStringText(get(data, 'layout.page_size')),
      margin_top: util.toNumber(get(data, 'layout.margin_top')),
      margin_left: util.toNumber(get(data, 'layout.margin_left')),
      margin_bottom: util.toNumber(get(data, 'layout.margin_bottom')),
      margin_right: util.toNumber(get(data, 'layout.margin_right')),
    };
  }

  return docData;
}

export function fetchPrintTemplateDropdown(app, params) {
  const { searchTerm, searchParams, fields, id } = params;
  const dropdown_type = `${DocType.PRINT_TEMPLATE}/dropdown`;
  const query = {
    id,
    dropdown_type,
    fields,
    searchTerm,
    searchParams,
  };

  return common.getDropdownList(app, { query });
}

export function savePrintTemplate(app, dataToSave) {
  const { user = {}, data = {} } = dataToSave;
  const doc = parseDocData(data);

  return common.saveDoc(app, {
    doc,
    user,
    source: data,
  });
}

export function fetchPrintTemplateById(app, params) {
  const { id } = params;
  const docType = DocType.PRINT_TEMPLATE;
  return common.getDoc(app, { id, docType });
}

export function deletePrintTemplate(app, data) {
  return common.deleteDoc(app, {
    id: data.id,
    docType: DocType.PRINT_TEMPLATE,
  });
}
